import React, { createContext, useContext, useState } from 'react';

import MapController from './MapController';

interface MapContextProps {
  map: MapController | null;
  setMap: React.Dispatch<React.SetStateAction<MapController | null>>;
}

const MapContext = createContext<MapContextProps | null>(null);

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [map, setMap] = useState<MapController | null>(null);

  return <MapContext.Provider value={{ map, setMap }}>{children}</MapContext.Provider>;
};

export const useMap = () => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMap must be used within a MapProvider');
  }
  return context;
};
